<template>
  <div>
    <logo/>
    <el-scrollbar :style='{ width: "calc(" + variables.sideBarWidth + " + 1px)", "margin-top": "10px", overflow: "hidden", height: "calc(100% - 40px)" }'>
      <el-menu :background-color='variables.menuBg' unique-opened
        :default-active='defaultActiveView' ref='elMenu'
        :default-openeds='defaultOpeneds'
        :text-color='variables.menuText' :active-text-color='variables.menuActiveText'>
        <sidebar-item v-for='menu in menus' :key='menu.MenuCode' :child='menu'/>
      </el-menu>
    </el-scrollbar>
  </div>
</template>

<script>
import SidebarItem from './SidebarItem'
import Logo from './Logo'
import variables from '@/styles/frame.scss'

export default {
  components: { SidebarItem, Logo },
  data: function () {
    return {
      menus: [],
      defaultActiveView: 'sys/sysset',
      defaultOpeneds: []
    }
  },

  computed: {
    variables: function () {
      return variables
    },
    userMenus: function () {
      return this.$store.state.userMenus
    },
    route: function () {
      return this.$route
    },
    showTabs: function () {
      return this.$store.state.showTabs
    }
  },

  watch: {
    userMenus: function () {
      this.updateMenu()
    },
    route: function (newVal, oldVal) {
      const that = this
      that.$store.dispatch('commitActiveMenuCode', that.$route.path.substring(1))
      if (that.showTabs) {
        that.$store.dispatch('commitAddOpenMenus', that.$route)
      }
      that.defaultActiveView = that.$route.path.substring(1)
      if (that.$route.matched[0].path.length > 0) {
        that.$refs.elMenu.open(that.$route.matched[0].path.substring(1))
      }
    }
  },

  created: function () {
    const that = this
    that.updateMenu()
    that.defaultActiveView = that.$route.path.substring(1)
    that.defaultOpeneds = [that.$route.path.substring(1)]
    if (that.$route.path.substring(1) !== 'index') {
      that.$store.dispatch('commitAddOpenMenus', {
        fullPath: '/index',
        hash: '',
        meta: { title: '主页', componentName: 'Index' },
        name: '主页',
        params: {},
        path: '/index',
        query: {}
      })
    }
    that.$store.dispatch('commitActiveMenuCode', that.$route.path.substring(1))
    if (that.showTabs) {
      that.$store.dispatch('commitAddOpenMenus', that.$route)
    }
  },

  methods: {
    updateMenu: function () {
      const that = this
      const menu1Infos = that.userMenus.concat([])
      menu1Infos.splice(0, 0, {
        Description: '主页',
        FilePath: 'index',
        Icon: 'sys sys-homepage',
        IsLeaf: '1',
        MenuCode: 'index',
        MenuLevel: 1,
        MenuName: '主页',
        Children: []
      })
      const newMenu1Infos = []
      for (let i = 0; i < menu1Infos.length; i++) {
        if (menu1Infos[i].IsLeaf !== '1' && menu1Infos[i].Children.length <= 0) {
          continue
        }
        newMenu1Infos.push(menu1Infos[i])
      }
      that.menus = newMenu1Infos
    }
  }
}
</script>
